// TODO: These imports are still using require. They should be converted to ES6 imports if the target files are modules.
// For now, I will assume they are not yet converted and leave them commented out or handle them as re-exports.
import * as commonCookies from './app/constants/cookies';
export * from '@nuxt-common/media-card-large/config.bcom';
export * from '@nuxt-common/fulfillment/config.bcom';
export * from '@nuxt-common/locator/config.bcom';
export * from '@nuxt-common/product-quickview/config.bcom';
export * from './config.bcom.atb';
export * from './config.bcom.atr';
export * from './config.bcom.ppc';

const CUSTOMER_SERVICE_DOMAIN = 'https://www.bloomingdales.com/customer-service';

export const brand = 'bcom';
export const brandName = "Bloomingdale's";
export const marketPlace = {
  phoneNumber: '1-800-777-0000',
  concernReportLink: 'https://survey.medallia.com/?blm-tuwyt-com',
  faqLink: 'https://www.bloomingdales.com/customer-service/articles/sold-and-shipped',
  faqLinkLtl: 'https://www.bloomingdales.com/customer-service/articles/sold-and-shipped-by-third-party-sellers',
};
export const storeLocatorParams = {
  // for nearby stores
  storeLocationType: 'BSTORE', // 'MSTORE' for mcom and default 'UPS'
  divisionNumber: 13, // 13 for Bloomingdale's stores and 12 for Macy's stores
  page: 'pdp',
};

// Re-exporting from other config files
export * from './config.bcom.atb';
export * from './config.bcom.atr';
export * from '@nuxt-common/media-card-large/config.bcom';
export * from './config.bcom.ppc';

export const denomination = [10, 25, 50, 75, 100, 150, 200, 250, 300, 350, 400, 450, 500, 1000];
export const customerServiceUrls = {
  bigTicketShipping: {
    international: `${CUSTOMER_SERVICE_DOMAIN}/app/answers/detail/a_id/354/theme/popup/`,
    domestic: `${CUSTOMER_SERVICE_DOMAIN}/app/answers/detail/a_id/354/theme/popup/`,
  },
  shipping: {
    international: `${CUSTOMER_SERVICE_DOMAIN}/app/answers/detail/a_id/354/theme/popup/`,
    domestic: `${CUSTOMER_SERVICE_DOMAIN}/app/answers/detail/a_id/354/theme/popup/`,
  },
  returns: {
    international: `${CUSTOMER_SERVICE_DOMAIN}/app/answers/detail/a_id/359/theme/popup/`,
    domestic: `${CUSTOMER_SERVICE_DOMAIN}/app/answers/detail/a_id/359/theme/popup/`,
  },
  reviews: {
    termsOfUse: `${CUSTOMER_SERVICE_DOMAIN}/articles/bloomingdales-terms-of-use`,
    userGeneratedContent: `${CUSTOMER_SERVICE_DOMAIN}/articles/user-generated-content`,
    contactUs: `${CUSTOMER_SERVICE_DOMAIN}/articles/contact-us`,
  },
};
export const cookies = {
  ...commonCookies,
  userId: 'bloomingdales_online_uid',
  userGuid: 'bloomingdales_online_guid',
  bagGuid: 'bloomingdales_bagguid',
};
export const topLevelCategoryID = {};
export const promotionalDetailsUrl = 'https://www.bloomingdales.com/shop/popup?perfectProxy=true&popupID=1742499021375';
export const promotionalDetailsUrlCommon = 'https://www.bloomingdales.com/shop/popup?perfectProxy=true&popupID=1742499021375';
export const promotionalDetailsUrlGuest = 'https://www.bloomingdales.com/shop/popup?perfectProxy=true&popupID=1742499021375';
export const promotionalCreateProfile = 'https://www.bloomingdales.com/loyallist/enrollment?action=createprofileandenroll';
export const reviewsImgBaseUrl = 'https://images.bloomingdalesassets.com/is/image/BLM/products/';
export const fulfillmentErrors = {
  SameDay: 'Not available for Same-Day Delivery',
  NextDay: 'Not available for Next-Day Delivery',
  Pickup: 'Not available for Pickup',
  ShipIt: 'Not available for Ship to Home',
};
export const wgdUnavailablePhoneNumber = '1-866-593-2540';
export const btAvailabilitySkeletonHeight = '18px';
